// FAMILY-EXT: контейнер для модала настроек доски. Диспатчит updateBoard/
// deleteBoard, а также пробрасывает project.background для редактирования
// фона прямо из этого модала (раньше для смены фона приходилось ходить
// в отдельные настройки проекта — теперь всё в одном месте).

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import BoardSettingsModal from '../components/BoardSettingsModal';

const mapStateToProps = (state) => {
  const currentProject = selectors.selectCurrentProject(state) || {};
  return {
    projectBackground: currentProject.background,
    projectBackgroundImage: currentProject.backgroundImage,
    isProjectBackgroundImageUpdating: !!currentProject.isBackgroundImageUpdating,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    {
      onProjectUpdate: entryActions.updateCurrentProject,
      onProjectBackgroundImageUpdate: entryActions.updateCurrentProjectBackgroundImage,
    },
    dispatch,
  ),
  onUpdate: (data) => dispatch(entryActions.updateBoard(ownProps.boardId, data)),
  onDelete: () => dispatch(entryActions.deleteBoard(ownProps.boardId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BoardSettingsModal);
